import UserPermissionsList from './UserPermissionsList.vue'
export { UserPermissionsList }
export default UserPermissionsList
